import React from "react";
import "./account.css";

export function Account() {
  return (
    <main>
      <h1>Coming soon</h1>
    </main>
  );
}
